/* @flow strict */

/* eslint-disable camelcase */
import * as React from 'react';
import { currency } from '/client/src/constants';
import { format } from '/client/src/utils/amountTransformation';
import { canCheckout } from '/client/src/utils/buyService';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import './footer.scss';
import '../checkout.scss';

type FooterPropsType = {
  buyCart: [],
  eventDetail: {
    default_currency: string
  },
  handleNextStep: () => void,
  currentStep: number,
  currentSubtotal: number | null,
  isRegistrationShow: boolean
};

const FooterTotal = (props: FooterPropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);

  const { buyCart, eventDetail, currentStep, handleNextStep, currentSubtotal, isRegistrationShow } = props;
  const isSelected = canCheckout(buyCart, buyCart);

  let ticketCount = 0;

  let donationAmount = 0;

  _.forEach(buyCart, (t: {}) => {
    if (_.has(t, 'goal')) {
      donationAmount += t.prefilled_amount;
    } else {
      ticketCount++;
    }
  });

  const steps = {
    1: <>Add to cart</>,
    2: <>Check out</>,
    3: <>Pay</>
  };

  if (isRegistrationShow) steps[4] = <>Submit</>;

  return (
    <div className={`sparxo-checkout-footer_container ${isSelected ? 'sparxo-checkout-footer_isSelected' : ''}`}>
      <div className="sparxo-checkout-footer_inner">
          <div className="sparxo-checkout-footer_info">
            {currentSubtotal > 0 && currentStep > 1 ?
              <div>Total: {format(currency[`${context.profileCurrent.currency}`], currentSubtotal)}</div>
              :
              <>
                <div>Tickets selected: {ticketCount}</div>
                {donationAmount > 0 &&
                <div className="sparxo-checkout-footer_donation">
                  Donation: {format(currency[`${context.profileCurrent.currency}`], donationAmount)}
                </div>
                }
              </>
            }
          </div>
          <button
            type="button"
            className="sparxo-checkout_action_btn"
            onClick={(): void => handleNextStep()}
          >
            {
              steps[currentStep]
            }
          </button>
      </div>
    </div>
  );
};

export default FooterTotal;
